import { message } from "antd";
import axios from "axios";
import { jwtDecode as jwt_decode } from "jwt-decode";
import { useSpin } from "../../components/SpinContext";
import { useNavigate } from "react-router-dom";
export const baseUrl = process.env.REACT_APP_BASE_URL + "api";
const storedTimeZone = localStorage.getItem("user_time_zone");

const handleHttpError = (error) => {
  if (error.response) {
    const statusCode = error?.response?.status;
    const messageText =
      error?.response?.statusText ||
      error?.response?.data?.message?.messageTypeId ||
      error?.response?.data?.message;

    if (statusCode === 401 || statusCode === 403) {
      localStorage.clear();
      message?.error(messageText);
    } else if (statusCode === 500) {
      message.error(messageText);
    } else {
      message.error(messageText);
    }
  } else if (error?.request) {
    message.error(error?.message);
  } else {
    message.error(error?.message);
  }

  return Promise.reject(error); // Reject the error to propagate it
};

const interceptor = {
  axiosPost: (method, urlPath, data, token) => {
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userToken = localStorage.getItem("@token");
    if (userToken) {
      const decodedToken = jwt_decode(userToken);
      userTimeZone = decodedToken?.user_time_zone
        ? decodedToken?.user_time_zone
        : userTimeZone;
    }
    return axios({
      method: method,
      url: `${baseUrl}${urlPath}`,
      data: data,
      //data: new URLSearchParams(data),
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        timezone: userTimeZone,
      },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },

  axiosWithoutHaeders: (method, urlPath, data) => {
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userToken = localStorage.getItem("@token");
    if (userToken) {
      const decodedToken = jwt_decode(userToken);
      userTimeZone = decodedToken?.user_time_zone
        ? decodedToken?.user_time_zone
        : userTimeZone;
    }
    return axios({
      method: method,
      url: `${baseUrl}${urlPath}`,
      data: data,
      headers: {
        Authorization: null,
        "Content-Type": "application/json",
        timeZone:
          localStorage.getItem("user_time_zone") ||
          Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },

  axiosPostForUpload: (method, urlPath, data, token) => {
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userToken = localStorage.getItem("@token");
    if (userToken) {
      const decodedToken = jwt_decode(userToken);
      userTimeZone = decodedToken?.user_time_zone
        ? decodedToken?.user_time_zone
        : userTimeZone;
    }
    return axios({
      method: method,
      url: `${baseUrl}${urlPath}`,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        timezone: userTimeZone,
      },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },
  axiosLogin: (method, urlPath, data, token) => {
    return axios({
      method: method,
      url: `${baseUrl}${urlPath}`,
      data: data,
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },

  axiosPut: (method, urlPath, data, token) => {
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userToken = localStorage.getItem("@token");
    if (userToken) {
      const decodedToken = jwt_decode(userToken);
      userTimeZone = decodedToken?.user_time_zone
        ? decodedToken?.user_time_zone
        : userTimeZone;
    }
    return axios({
      method: method,
      url: `${baseUrl}${urlPath}`,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        timezone: userTimeZone,
      },
      // headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/x-www-form-urlencoded' },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },

  axiosPatch: (method, urlPath, data, token) => {
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userToken = localStorage.getItem("@token");
    if (userToken) {
      const decodedToken = jwt_decode(userToken);
      userTimeZone = decodedToken?.user_time_zone
        ? decodedToken?.user_time_zone
        : userTimeZone;
    }
    return axios({
      method: method,
      url: `${baseUrl}${urlPath}`,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        timezone: userTimeZone,
      },
      // headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/x-www-form-urlencoded' },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },

  axiosGet: (method, urlPath, token, data) => {
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userToken = localStorage.getItem("@token");
    if (userToken) {
      const decodedToken = jwt_decode(userToken);
      userTimeZone = decodedToken?.user_time_zone
        ? decodedToken?.user_time_zone
        : userTimeZone;
    }

    return axios({
      method: method,
      url: `${baseUrl}${urlPath}`,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        timezone: userTimeZone,
      },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },

  axiosGetWithParams: (method, urlPath, token, data) => {
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userToken = localStorage.getItem("@token");
    if (userToken) {
      const decodedToken = jwt_decode(userToken);
      userTimeZone = decodedToken?.user_time_zone
        ? decodedToken?.user_time_zone
        : userTimeZone;
    }
    return axios({
      method: method,
      url: `${baseUrl}${urlPath}`,
      //data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        timezone: userTimeZone,
      },
      params: data,
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },

  axiosDelete: (method, urlPath, data, token) => {
    let userTimeZone =  Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userToken = localStorage.getItem("@token");
    if (userToken) {
      const decodedToken = jwt_decode(userToken);
      userTimeZone = decodedToken?.user_time_zone
        ? decodedToken?.user_time_zone
        : userTimeZone;
    }
    return axios({
      method: method,
      url: `${baseUrl}${urlPath}`,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        timezone: userTimeZone,
      },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },

  // Post Chunks Upload Porfile Picture
  axiosUploadProfilePic: (method, urlPath, data, token) => {
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userToken = localStorage.getItem("@token");
    if (userToken) {
      const decodedToken = jwt_decode(userToken);
      userTimeZone = decodedToken?.user_time_zone
        ? decodedToken?.user_time_zone
        : userTimeZone;
    }
    return axios({
      url: `${baseUrl}${urlPath}`,
      method: method,
      data: new URLSearchParams(data),
      headers: {
        Authorization: `Bearer ${token}`,
        timezone: userTimeZone,
      },
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },

  axiosGetDownload: (method, urlPath, token, data) => {
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let userToken = localStorage.getItem("@token");
    if (userToken) {
      const decodedToken = jwt_decode(userToken);
      userTimeZone = decodedToken?.user_time_zone
        ? decodedToken?.user_time_zone
        : userTimeZone;
    }
    return axios({
      method: method,
      url: `${baseUrl}${urlPath}`,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        timezone: userTimeZone,
      },
      responseType: "blob",
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return handleHttpError(error); // Handle error without needing hideSpin to be passed
      });
  },
};

export default interceptor;
